import { useEffect, useState } from "react";
import {
    Bell,
    CalendarDays,
    Filter,
    MessageCircleMore,
    RotateCcw,
    Search,
    TriangleAlert,
    ChevronUp,
    ChevronDown,
} from "lucide-react";
import { Badge, Button, Card, Input, Tabs, Select } from "antd";
import { AnimatePresence, motion } from "framer-motion";
import dayjs from "dayjs";
import CustomerTable from "./CustomerTable";
import Layout from '../../Layout'
import { getCompletedAppointments, CompletedAppointment } from "../../api/AppointmentCare";

const stats = [
    {
        title: "ĐẾN LỊCH HÔM NAY",
        value: "24",
        color: "#1890ff",
        icon: <CalendarDays size={22} />,
    },
    {
        title: "CẦN MỜI QUAY LẠI",
        value: "12",
        color: "#22c55e",
        icon: <RotateCcw size={22} />,
    },
    {
        title: "CHƯA PHẢN HỒI",
        value: "08",
        color: "#f59e0b",
        icon: <MessageCircleMore size={22} />,
    },
    {
        title: "CẢNH BÁO / BIẾN CHỨNG",
        value: "02",
        color: "#ef4444",
        danger: true,
        icon: <TriangleAlert size={22} />,
    },
];

const AVATAR_COLORS = ["#E9D5FF", "#DBEAFE", "#DCFCE7", "#FEF3C7", "#FEE2E2", "#CFFAFE"];

// Điểm CSAT trung bình từ 4 tiêu chí khảo sát (1 chữ số thập phân)
const avgCsat = (item: CompletedAppointment): number | null => {
    const r = item.survey_data?.ratings;
    if (!r) return null;
    const vals = [r.quality, r.staff_attitude, r.doctor_ktv, r.facilities].map(Number).filter((v) => v > 0);
    if (!vals.length) return null;
    return Math.round((vals.reduce((s, v) => s + v, 0) / vals.length) * 10) / 10;
};

export default function CareListPage() {
    const [showFilter, setShowFilter] = useState(false);
    // Phần tử trên toolbar để bảng đặt nút cài đặt cột vào (qua portal)
    const [columnSettingSlot, setColumnSettingSlot] = useState<HTMLDivElement | null>(null);

    // Danh sách lịch hẹn đã thực hiện (API /appointments/completed)
    const [items, setItems] = useState<CompletedAppointment[]>([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [loading, setLoading] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [search, setSearch] = useState("");
    const [isCared, setIsCared] = useState<number | undefined>(undefined);
    // Giá trị nháp trong panel "Bộ lọc nâng cao" (chỉ áp dụng khi bấm "Áp dụng lọc")
    const [draftCared, setDraftCared] = useState<number | undefined>(undefined);

    const fetchList = () => {
        setLoading(true);
        getCompletedAppointments({ search: search || undefined, is_cared: isCared, page, limit: pageSize }).then((res) => {
            setItems(res.status ? res.items : []);
            setTotal(res.status ? res.total : 0);
            setLoading(false);
        });
    };

    useEffect(() => {
        fetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, pageSize, search, isCared]);

    const rows = items.map((it, i) => ({
        key: it.id,
        id: it.id,
        avatar: (it.customer_name || "?").trim().charAt(0).toUpperCase(),
        color: AVATAR_COLORS[i % AVATAR_COLORS.length],
        name: it.customer_name || "—",
        code: it.code,
        phone: it.customer_phone || "—",
        service: (it.services || []).map((s) => s.name).join(", ") || "—",
        doctor: it.action_staff_name || "",
        date: it.scheduled_at ? dayjs(it.scheduled_at).format("DD/MM/YYYY") : "—",
        is_cared: it.is_cared,
        status: it.care_status_text || (it.is_cared ? "Đã chăm sóc" : "Chưa chăm sóc"),
        statusColor: it.is_cared ? "green" : "orange",
        cared_at: it.cared_at,
        cared_by_staff_name: it.cared_by_staff_name,
        survey_data: it.survey_data,
        csat: avgCsat(it),
    }));
    return (
        <Layout>

            {/* Header */}

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">

                <h2 className="text-sm sm:text-3xl font-bold text-000000e0">
                    Danh sách cần chăm sóc
                </h2>

                {/* <div className="flex items-center gap-4">

                    <Input
                        placeholder="Tìm tên, SĐT khách hàng..."
                        prefix={<Search size={18} />}
                        className="w-full lg:w-[300px] h-11 rounded-xl"
                    />
                </div> */}

            </div>

            {/* Summary */}

            {/* <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 mt-6">

                {stats.map((item) => (
                    <Card
                        key={item.title}
                        className={`rounded-2xl border transition-all hover:shadow-lg ${item.danger ? "border-red-300" : ""
                            } dark:bg-[#262626] dark:border-neutral-700`}
                        bodyStyle={{ padding: 22 }}
                    >
                        <div className="flex items-center justify-between">

                            <div>

                                <p
                                    className={`text-sm font-medium ${item.danger ? "text-red-500" : "text-slate-500"
                                        }`}
                                >
                                    {item.title}
                                </p>

                                <h2
                                    className={`text-5xl font-bold mt-3 ${item.danger ? "text-red-500" : "dark:text-white"
                                        }`}
                                >
                                    {item.value}
                                </h2>

                            </div>

                            <div
                                className="w-14 h-14 rounded-full flex items-center justify-center"
                                style={{
                                    background: `${item.color}15`,
                                    color: item.color,
                                }}
                            >
                                {item.icon}
                            </div>

                        </div>
                    </Card>
                ))}

            </div> */}

            {/* Content */}

            <Card
                className="mt-6 rounded-2xl dark:bg-[#262626] dark:border-neutral-700"
                bodyStyle={{ padding: 16 }}
            >

                <div className="flex flex-col lg:flex-row lg:justify-between gap-4 lg:items-center">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                        <Input
                            placeholder="Tìm mã lịch hẹn, tên, SĐT khách hàng..."
                            prefix={<Search size={18} />}
                            className="w-full lg:w-[320px] h-[32px]"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            onPressEnter={() => { setPage(1); setSearch(searchInput.trim()); }}
                            allowClear
                            onClear={() => { setPage(1); setSearch(""); }}
                        />
                    </div>

                    {/* <Tabs
                        defaultActiveKey="1"
                        items={[
                            {
                                key: "1",
                                label: "Tất cả",
                            },
                            {
                                key: "2",
                                label: "Vừa hoàn thành",
                            },
                            {
                                key: "3",
                                label: "Đến lịch chăm sóc",
                            },
                            {
                                key: "4",
                                label: "Khách VIP",
                            },
                            {
                                key: "5",
                                label: (
                                    <span className="text-red-500 flex items-center gap-1">
                                        <TriangleAlert size={15} />
                                        Cảnh báo
                                    </span>
                                ),
                            },
                        ]}
                    /> */}

                    <div className="flex items-center gap-2">
                        <Button
                            onClick={() => setShowFilter(!showFilter)}
                            icon={<Filter size={16} />}
                        >
                            Bộ lọc nâng cao
                            {showFilter ? (
                                <ChevronUp className="ml-2" size={16} />
                            ) : (
                                <ChevronDown className="ml-2" size={16} />
                            )}
                        </Button>
                        {/* Chỗ đặt nút cài đặt cột của bảng (chỉ bản desktop có bảng) */}
                        <div ref={setColumnSettingSlot} className="hidden lg:flex" />
                    </div>
                </div>

                <AnimatePresence>
                    {showFilter && (
                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.25 }}
                            className="overflow-hidden"
                        >
                            <div className="border-t mt-5 pt-5">
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4">

                                    <div>
                                        <label className="text-sm mb-2 block text-000000e0">
                                            Thời gian làm dịch vụ
                                        </label>

                                        <Select
                                            className="w-full"
                                            defaultValue="7 ngày qua"
                                            options={[
                                                { label: "Hôm nay", value: 1 },
                                                { label: "7 ngày qua", value: 7 },
                                                { label: "30 ngày qua", value: 30 },
                                            ]}
                                        />
                                    </div>

                                    <div>
                                        <label className="text-sm mb-2 block text-000000e0">
                                            Dịch vụ đã làm
                                        </label>

                                        <Select
                                            className="w-full"
                                            defaultValue="Tất cả dịch vụ"
                                            options={[
                                                {
                                                    label: "Tất cả dịch vụ",
                                                    value: 0,
                                                },
                                            ]}
                                        />
                                    </div>

                                    <div>
                                        <label className="text-sm mb-2 block text-000000e0">
                                            Người thực hiện
                                        </label>

                                        <Select
                                            className="w-full"
                                            defaultValue="Tất cả Bác sĩ / KTV"
                                            options={[
                                                {
                                                    label: "Tất cả Bác sĩ / KTV",
                                                    value: 0,
                                                },
                                            ]}
                                        />
                                    </div>

                                    <div>
                                        <label className="text-sm mb-2 block text-000000e0">
                                            Trạng thái chăm sóc
                                        </label>

                                        <Select
                                            className="w-full"
                                            placeholder="Tất cả trạng thái"
                                            allowClear
                                            value={draftCared}
                                            onChange={(v) => setDraftCared(v)}
                                            options={[
                                                { label: "Đã chăm sóc", value: 1 },
                                                { label: "Chưa chăm sóc", value: 0 },
                                            ]}
                                        />
                                    </div>

                                    <div>
                                        <label className="text-sm mb-2 block text-000000e0">
                                            Mức độ hài lòng (CSAT)
                                        </label>

                                        <Select
                                            className="w-full"
                                            defaultValue="Tất cả đánh giá"
                                            options={[
                                                {
                                                    label: "Tất cả đánh giá",
                                                    value: 0,
                                                },
                                            ]}
                                        />
                                    </div>

                                </div>

                                <div className="flex justify-end gap-3 mt-5">

                                    <Button
                                        icon={<RotateCcw size={16} />}
                                        onClick={() => { setDraftCared(undefined); setPage(1); setIsCared(undefined); }}
                                    >
                                        Xóa bộ lọc
                                    </Button>

                                    <Button
                                        type="primary"
                                        onClick={() => { setPage(1); setIsCared(draftCared); }}
                                    >
                                        Áp dụng lọc
                                    </Button>

                                </div>
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>

                <div className="mt-5">
                    <CustomerTable
                        data={rows}
                        loading={loading}
                        pagination={{
                            current: page,
                            pageSize,
                            total,
                            onChange: (p: number, ps: number) => { setPage(p); setPageSize(ps); },
                        }}
                        onRefresh={fetchList}
                        columnSettingSlot={columnSettingSlot}
                    />
                </div>

            </Card>

        </Layout>
    );
}